import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as CSC from "SC";
import { CommonOutletTemplate } from "UI/CommonOutletTemplate";

import { useDataGrid } from "hooks/useDataGrid";
import { useCurrentUserData } from "hooks/useUserData";
import { useRegions } from "hooks/useRegions";
import { EditPracticeDialog } from "./EditPracticeDialog";
import { AddNewPracticeDialog } from "./AddNewPracticeDialog";
import { GlobalContext } from "store/globalContext";
import { DataGrid } from "UI/DataGrid";
import { TextFieldWithEllipsis } from "UI/TextFiledWithEllipsis";

const columns = [
  {
    label: "Name",
    field: "name",
    xs: 3.25,
    sm: 3.25,
    md: 3.25,
    renderer: ({ name }) => (
      <TextFieldWithEllipsis>{name}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Speciality",
    field: "speciality",
    xs: 1.5,
    sm: 1.5,
    md: 1.5,
    renderer: ({ speciality }) => (
      <TextFieldWithEllipsis>{speciality}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Phone",
    field: "phone",
    xs: 1.5,
    sm: 1.5,
    md: 1.5,
  },
  // {
  //   label: "Email",
  //   field: "email",
  //   xs: 2.75,
  //   sm: 2.75,
  //   md: 2.75,
  //   renderer: ({ email }) => (
  //     <TextFieldWithEllipsis>{email}</TextFieldWithEllipsis>
  //   ),
  // },
  {
    label: "City",
    field: "city",
    xs: 1,
    sm: 1,
    md: 1,
  },
  {
    label: "State",
    field: "state",
    xs: 0.75,
    sm: 0.75,
    md: 0.75,
  },
  {
    label: "ZIP",
    field: "zipCode",
    xs: 1,
    sm: 1,
    md: 1,
  },
  {
    label: "Region",
    field: "label",
    xs: 1.5,
    sm: 1.5,
    md: 1.5,
  },
  {
    label: "Added by",
    field: "creatorName",
    xs: 1.5,
    sm: 1.5,
    md: 1.5,
    renderer: ({ creatorName }) => (
      <TextFieldWithEllipsis>{creatorName}</TextFieldWithEllipsis>
    ),
  },
];

const mobileColumns = [
  {
    label: "Name",
    field: "name",
    xs: 5,
    sm: 5,
    md: 5,
    renderer: ({ name }) => (
      <TextFieldWithEllipsis>{name}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Speciality",
    field: "speciality",
    xs: 4,
    sm: 4,
    md: 4,
    renderer: ({ speciality }) => (
      <TextFieldWithEllipsis>{speciality}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Phone",
    field: "phone",
    xs: 3,
    sm: 3,
    md: 3,
  },
];

const superAdmincolumns = [
  {
    label: "Name",
    field: "name",
    xs: 3.25,
    sm: 3.25,
    md: 3.25,
    renderer: ({ name }) => (
      <TextFieldWithEllipsis>{name}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Speciality",
    field: "speciality",
    xs: 2,
    sm: 2,
    md: 2,
    renderer: ({ speciality }) => (
      <TextFieldWithEllipsis>{speciality}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Phone",
    field: "phone",
    xs: 2,
    sm: 2,
    md: 2,
  },
  // {
  //   label: "Email",
  //   field: "email",
  //   xs: 3.25,
  //   sm: 3.25,
  //   md: 3.25,
  //   renderer: ({ email }) => (
  //     <TextFieldWithEllipsis>{email}</TextFieldWithEllipsis>
  //   ),
  // },
  {
    label: "City",
    field: "city",
    xs: 1.5,
    sm: 1.5,
    md: 1.5,
  },
  {
    label: "State",
    field: "state",
    xs: 0.75,
    sm: 0.75,
    md: 0.75,
  },
  {
    label: "Added by",
    field: "creatorName",
    xs: 2.5,
    sm: 2.5,
    md: 2.5,
    renderer: ({ creatorName }) => (
      <TextFieldWithEllipsis>{creatorName}</TextFieldWithEllipsis>
    ),
  },
];

const superAdminMobilecolumns = [
  {
    label: "Name",
    field: "name",
    xs: 5,
    sm: 5,
    md: 5,
    renderer: ({ name }) => (
      <TextFieldWithEllipsis>{name}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Phone",
    field: "phone",
    xs: 3,
    sm: 3,
    md: 3,
  },
  {
    label: "Added by",
    field: "creatorName",
    xs: 4,
    sm: 4,
    md: 4,
    renderer: ({ creatorName }) => (
      <TextFieldWithEllipsis>{creatorName}</TextFieldWithEllipsis>
    ),
  },
];

const comment =
  "Physical locations where Senders work/practice (office, surgery center, clinic, etc.)";

export const Practices = () => {
  const navigate = useNavigate();
  const { isReadOnlyAccess } = useCurrentUserData();
  const { regionsOptions, refreshRegionsOptions } = useRegions();
  const { userData } = useContext(GlobalContext);

  const [isAddNewDialogOpen, setIsAddNewDialogOpen] = useState(false);
  const [currentPracticeId, setCurrentPracticeId] = useState("");

  const dataGrid = useDataGrid({
    url: "/organizations/list",
    defaultSorter: {
      name: "name",
      order: "asc",
    },
    defaultLimit: 25,
    gridConfigIndex: `${userData.cognitoId}-Practices`,
  });

  const handleRowClick = ({ id }) => navigate(`/practice/${id}`);

  const isSuperAdmin = userData?.role === "Super Admin" || userData?.email === "admin@referral-stream.com";

  const disableDownload =
    userData?.role !== "Super Admin" && userData?.role !== "Admin";

  return (
    <CommonOutletTemplate
      title="Practices"
      comment={comment}
      isLoading={!dataGrid?.rows}
    >
      <DataGrid
        columns={isSuperAdmin ? superAdmincolumns : columns}
        mobileColumns={isSuperAdmin ? superAdminMobilecolumns : mobileColumns}
        handleRowClick={handleRowClick}
        {...dataGrid}
        disableDownload={disableDownload}
        afterSearchContent={
          <CSC.BlueButton
            variant="outlined"
            onClick={() => setIsAddNewDialogOpen(true)}
            size="small"
          >
            Add New Practice
          </CSC.BlueButton>
        }
      />
      {!isReadOnlyAccess && (
        <>
          <AddNewPracticeDialog
            open={isAddNewDialogOpen}
            handleClose={() => setIsAddNewDialogOpen(false)}
            refreshList={dataGrid.loadData}
            regionsOptions={regionsOptions}
            refreshRegionsOptions={refreshRegionsOptions}
          />

          <EditPracticeDialog
            open={!!currentPracticeId}
            practiceId={currentPracticeId}
            handleClose={() => setCurrentPracticeId("")}
            refreshList={dataGrid.loadData}
            regionsOptions={regionsOptions}
            refreshRegionsOptions={refreshRegionsOptions}
          />
        </>
      )}
    </CommonOutletTemplate>
  );
};
